import { Permission, IssueStatus } from 'shared'
import CIMSFormItem from 'components/CIMSFormItem'
import { useDisabledOptions } from 'hooks/useDisabledOptions'
import CIMSTextArea from 'components/CIMSTextArea'
import { useValidateWhitespaceProps } from 'components/CIMSTextArea/hooks/useValidateWhitespaceProps'
import { useCheckPermission } from 'hooks/useCheckPermission'
import { HelpMessage } from 'utils/constants'
import { Issue } from '../../../../../IssueTrackerContext/types'

const Response: React.VFC<Pick<Issue, 'statusId'>> = ({ statusId }) => {
  const [disabled, { some }] = useDisabledOptions([
    {
      disabled: !useCheckPermission(Permission.EditIssueResponse),
      reason: 'missing permission',
    },
    {
      disabled: statusId === IssueStatus.Closed.id,
      reason: { why: 'invalid status', statusName: IssueStatus.Closed.name },
    },
    {
      disabled: statusId === IssueStatus.Draft.id,
      reason: { why: 'invalid status', statusName: IssueStatus.Draft.name },
    },
    {
      disabled: statusId === IssueStatus.PendingResponse.id,
      reason: {
        why: 'disabled',
        message: 'Enter the response using the Pending Response button',
      },
    },
  ])
  return (
    <CIMSFormItem
      help={HelpMessage.Issues.IssueTracker.Response}
      name="response"
      disabled={disabled}
      {...useValidateWhitespaceProps({
        label: 'Response',
        required:
          statusId === IssueStatus.Draft.id ||
          statusId === IssueStatus.PendingResponse.id
            ? undefined
            : true,
      })}
    >
      <CIMSTextArea maxLength={2000} disabled={some} />
    </CIMSFormItem>
  )
}

export default Response
